import { cn } from '@/utils/styles';
import { Card } from '@design-system/Card';
import { Link } from '@design-system/Link';
import { Skeleton } from '@design-system/Skeleton';
import { List, ListItem } from '@design-system/List';

export interface IUserHealthHistory {
  allergies?: string;
  foodSensitives?: string;
  pregnancyStatus?: string;
  currentlyBreastfeeding?: string;
}

export interface MyHealthHistoryPageStatusSectionProps
  extends React.ComponentProps<'div'> {
  isLoading?: boolean;
  healthHistory?: IUserHealthHistory;
}

type IHealthHistoryData = {
  to?: string;
  label: string;
  value?: string | number;
};

const renderUserData = (
  healthHistoryData: IHealthHistoryData[],
  isLoading?: boolean,
) => {
  const renderedUserData = healthHistoryData.map((data) => {
    if (data.to) {
      return (
        <ListItem key={data.label} asChild>
          <Link to={data.to}>{data.label}</Link>
        </ListItem>
      );
    }

    return (
      <ListItem key={data.label} hideIndicator>
        {data.label}

        {isLoading ? (
          <Skeleton className="ml-auto w-full h-4 max-w-24" />
        ) : (
          <span className="ml-auto text-secondary truncate">
            <abbr title={String(data.value)} className="no-underline">
              {data.value}
            </abbr>
          </span>
        )}
      </ListItem>
    );
  });

  return renderedUserData;
};

export const MyHealthHistoryPageStatusSection = ({
  isLoading,
  className,
  healthHistory,
}: MyHealthHistoryPageStatusSectionProps) => {
  const healthHistoryData = [
    {
      label: 'Pregnancy Status',
      value: healthHistory?.pregnancyStatus,
    },
    {
      label: 'Currently Breastfeeding',
      value: healthHistory?.currentlyBreastfeeding,
    },
    {
      label: 'Current Reported Condition',
      to: '#',
    },
    {
      label: 'Allergies Reported',
      value: healthHistory?.allergies,
    },
    {
      label: 'Food Sensitivities Reported',
      value: healthHistory?.foodSensitives,
    },
  ] satisfies IHealthHistoryData[];

  return (
    <Card className={cn('overflow-hidden', className)}>
      <List>{renderUserData(healthHistoryData, isLoading)}</List>
    </Card>
  );
};
